<template>
  <div class="wrapper">
    <div v-if="!current" class="layout column fill-height">
      There is no slide to localize.
      <br />Maybe the selected slides already exists in your target country. <br />Please select a different
      set and try again.
      <v-spacer />
      <div class="mt-4">
        <core-button v-if="!current" label="Ok" flat not-rounded @click.stop="endLocalization(false)" />
      </div>
    </div>
    <div v-else>
      <div class="header mb-2 layout align-center">
        <div class="layout align-center">
          <v-chip small>
            Master
          </v-chip>
          &#8674;
          <v-chip color="primary" small>
            {{ targetCountry }}
          </v-chip>
        </div>
        <v-spacer />
        <div class="meta">
          <div>{{ current.externalId }}</div>
          <div>{{ current.name }}</div>
        </div>
      </div>
      <div v-if="current" class="preview">
        <v-img :src="current.asset.public.png" />
      </div>
      <div class="pager layout align-center justify-center">
        SLIDE {{ currentIndex }}/{{ possibleSlidesCount }}
      </div>
      <div class="actions mt-3 layout align-center">
        <v-btn v-if="currentIndex > 1" text @click.stop="previousStep">
          Previous Slide
        </v-btn>
        <v-spacer />
        <core-button
          v-if="currentIndex < possibleSlidesCount"
          :disabled="current.mandatory === true"
          class="mr-3"
          label="No Copy"
          secondary
          not-rounded
          flat
          @click.stop="noCopy(false)"
        />
        <core-button
          v-if="currentIndex === possibleSlidesCount"
          :disabled="current.mandatory === true"
          class="mr-3"
          label="No Copy and Finish"
          secondary
          not-rounded
          flat
          @click.stop="noCopy(true)"
        />

        <core-button
          v-if="currentIndex < possibleSlidesCount"
          label="Copy Slide"
          not-rounded
          flat
          @click.stop="copy(current)"
        />
        <core-button
          v-if="currentIndex === possibleSlidesCount"
          label="Copy Slide and Finish"
          not-rounded
          flat
          :is-loading="isLocalizing"
          @click.stop="finishProcessCopy(current)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import localization from '@/mixins/localization-mixin';
import { mapState } from 'vuex';
import CoreButton from '../../core/buttons/CoreButton';
import gql from 'graphql-tag';

export default {
  name: 'CopySlides',
  components: { CoreButton },
  mixins: [localization],
  data() {
    return {
      jobId: null,
      isLocalizing: false,
      hasError: false
    };
  },
  computed: {
    ...mapState('localization', {
      next: ({ localization }) => localization.slides.next,
      previous: ({ localization }) => localization.slides.previous,
      currentIndex: ({ localization }) => localization.slides.currentIndex + 1,
      possibleSlidesCount: ({ localization }) => localization.slides.items.length,
      current: ({ localization }) => localization.slides.current,
      targetCountry: ({ localization }) => localization.targetCountry,
      finalItems: ({ localization }) => localization.slides.finalItems
    })
  },
  watch: {
    'job.status': {
      handler(o) {
        if (o === 'error' || o === 'success') {
          this.isLocalizing = false;
          if (o === 'success') {
            this.$store.dispatch(
              'alerts/success',
              `You successfully copied ${this.finalItems.length} slides to country: ${this.targetCountry}.`
            );
            this.endLocalization(false);
          }
        }
      }
    }
  },
  methods: {
    async finishProcessCopy(current) {
      this.copy(current, true);
      this.isLocalizing = true;
      try {
        const job = await this.duplicate();
        if (job) {
          this.jobId = job._id;
        }
      } catch (e) {
        this.isLocalizing = false;
        this.$store.dispatch('alerts/warning', 'Not able to create localization');
      }
    }
  },
  apollo: {
    job: {
      query: gql`
        query($id: String) {
          getJob(id: $id) {
            _id
            status
            stages {
              name
              status
            }
          }
        }
      `,
      skip() {
        return !this.isLocalizing || !this.jobId;
      },
      update: data => data.getJob,
      pollInterval: 500,
      variables() {
        return {
          id: this.jobId
        };
      }
    }
  }
};
</script>

<style scoped>
.pager {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  color: #4a4a4a;
}
.meta {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
</style>
